export const camelToSnakeCase = str => {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
};
export const snakeToCamelCase = str => {
  return str.replace(/(_\w)/g, match => match[1].toUpperCase());
};
export const toTitleCase = str => {
  return str
    .replace(/_/g, ' ')
    .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
}
// "Hello world!" -> "hello_world"
export const toSnake = (s) =>
  (s ?? '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '_')
    .replace(/^_+|_+$/g, '');

export const normalizeFieldName = (name = "") =>
  name
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")  // replace any non-alphanumeric sequence with _
    .replace(/^_+|_+$/g, "");    // trim leading/trailing _